import { useMemo } from 'react';
import { type PSAPInfo } from '@rsos/reduxDataStore';
import type { StateWithSinatra } from '@rsos/sinatra/src/types/SinatraState';
import { type SmartPhraseContext } from '@rsos/utils/SmartPhrases';

type Args = {
  psap?: PSAPInfo;
  user?: StateWithSinatra['sinatra']['user'];
  token?: string;
  orgName?: string;
  callerID?: string;
};

export default function useSmartPhraseContext({
  psap,
  user,
  token,
  orgName,
  callerID,
}: Args = {}): SmartPhraseContext {
  return useMemo(
    () => ({
      orgName: orgName,
      token: token,
      accountId: psap?.account_id,
      agencyName: psap?.name,
      agencyState: psap?.state,
      contactName: psap?.contact_name,
      contactTitle: psap?.contact_title,
      contactPhone: psap?.contact_phone,
      contactEmail: psap?.contact_email,
      nonEmergencyPhone: psap?.non_emergency_phone,
      userEmail: user?.profile?.email,
      userFirstName: user?.profile?.first_name,
      userLastName: user?.profile?.last_name,
      callerID: callerID,
    }),
    [orgName, token, psap, user, callerID],
  );
}
